// Simple formatting for display purposes only
export function formatBookName(book: string): string {
  if (!book) return '';
  
  // Keep only basic display formatting
  return book
    .split('-')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

// Book groupings for navigation
export const OLD_TESTAMENT = {
  'Law': ['genesis', 'exodus', 'leviticus', 'numbers', 'deuteronomy'],
  'History': ['joshua', 'judges', 'ruth', '1-samuel', '2-samuel', '1-kings', '2-kings', '1-chronicles', '2-chronicles', 'ezra', 'nehemiah', 'esther'],
  'Poetry': ['job', 'psalms', 'proverbs', 'ecclesiastes', 'songofsolomon'],
  'Major Prophets': ['isaiah', 'jeremiah', 'lamentations', 'ezekiel', 'daniel'],
  'Minor Prophets': ['hosea', 'joel', 'amos', 'obadiah', 'jonah', 'micah', 'nahum', 'habakkuk', 'zephaniah', 'haggai', 'zechariah', 'malachi']
};

export const NEW_TESTAMENT = {
  'Gospels': ['matthew', 'mark', 'luke', 'john'],
  'History': ['acts'],
  'Pauline Epistles': ['romans', '1-corinthians', '2-corinthians', 'galatians', 'ephesians', 'philippians', 'colossians', '1-thessalonians', '2-thessalonians', '1-timothy', '2-timothy', 'titus', 'philemon'],
  'General Epistles': ['hebrews', 'james', '1-peter', '2-peter', '1-john', '2-john', '3-john', 'jude'],
  'Prophecy': ['revelation']
};